import { phasesOf, titleCase } from '@nsb/core';
import type { ProcessModel } from './useProcess.ts';

/** Where a step of the tree would land now, in words, when that is late: its title, its own phase and the one it lands in. */
export function lateWords(model: ProcessModel, key: string): { title: string; from: string; into: string } | null {
  const land = model.landing(key);
  if (!land.late || !land.from) return null;
  const name = (k: string) => phasesOf(model.dto.tree).find((p) => p.key === k)?.name ?? k;
  return { title: titleCase(model.tree.node(key)?.title ?? key), from: name(land.from), into: name(land.phase) };
}
